<template>
  <div>
    <nav
      id="topnav"
      class="navbar navbar-vertical fixed-left navbar-expand-md navbar-dark dark-bg"
    >
      <BContainer fluid class="topnav-container">
        <BRow class="align-items-start justify-content-center">
          <BCol cols="12" class="d-flex justify-content-center">
            <BNavbarToggle
              class="topnav-toggle"
              :aria-controls="'navbar-toggle-collapse'"
              :aria-expanded="showMenu"
              @click="toggleMenu"
            >
              <span class="navbar-toggler-icon"></span>
            </BNavbarToggle>

            <BNavbarBrand
              href="https://www.gofindbuild.com"
              target="_blank"
              rel="noopener"
              style="margin-right: 0px"
            >
              <img class="nav-icon" :src="`/img/icons/gfb-logo-large.svg`" />
            </BNavbarBrand>
          </BCol>

          <div
            id="navbar-toggle-collapse"
            v-show="showMenu"
            class="navbar-collapse collapse show topnav-collapse"
          >
            <BNavbarNav class="ml-auto">
              <BNavItem
                v-for="item in sidebarItems"
                :key="item.title"
                class="nav-link mini-list-item nav-item-with-dot"
                @click="goTo(item.to)"
              >
                <component :is="item.icon" size="24" />
                <i :class="item.icon" class="mr-2"></i>
                {{ item.title }}
                <span class="nav-title">
                  <span
                    v-if="
                      ((item.title === 'Find employees' ||
                        item.title === 'Find Jobs') &&
                        hasJobBriefingNotification) ||
                      (item.title === 'Trade Partners' &&
                        hasProjectNotification) ||
                      (item.title === 'Find employees' && isNewApplicants)
                    "
                    class="notification-dot"
                  ></span>
                  <span
                    v-if="item.title === 'Messages' && unreadCount > 0"
                    class="unread-count-badge"
                    >{{
                      unreadCount > 99 ? "99+ unread" : unreadCount + " unread"
                    }}</span
                  >
                </span>
              </BNavItem>

              <BNavItem
                :key="'Support'"
                class="nav-link mini-list-item"
                @click="handleSupportModal"
              >
                <img
                  class="nav-icon mr-2"
                  :src="`/img/icons/Support 1 1.svg`"
                />
                Support
              </BNavItem>

              <li
                v-if="profileType === 'company'"
                class="mini-list-group-item nav-link nav-group"
                :class="{
                  'current-route':
                    $route.path === '/toolbox/settings' ||
                    $route.path === '/toolbox/billing' ||
                    $route.path === '/toolbox/users-management',
                }"
              >
                <button
                  class="nav-group-toggle"
                  type="button"
                  @click="companyItems.active = !companyItems.active"
                >
                  <span class="sidebar-link-icon">
                    <component :is="companyItems.icon" size="24" />
                    <span class="tooltipText" v-if="mini">
                      {{ companyItems.title }}
                    </span>
                  </span>
                  <span class="sidebar-link-text">
                    <span class="nav-group-title-row">
                      <span v-text="companyItems.title"></span>
                      <span
                        class="nav-group-chevron nav-group-chevron-inline"
                        :class="{ open: companyItems.active }"
                      >
                        <PhCaretDown size="16" weight="bold" />
                      </span>
                    </span>
                    <small>{{ companyItems.companyName }}</small>
                  </span>
                </button>

                <ul v-show="companyItems.active" class="nav-group-items">
                  <li
                    v-for="child in companyItems.items"
                    :key="child.title"
                    class="nav-link mini-list-item"
                    :class="{ 'current-route': $route.path === child.to }"
                    @click="goTo(child.to)"
                  >
                    <span class="sidebar-link-icon">
                      <component :is="child.icon" size="24" />
                      <span class="tooltipText" v-if="mini">
                        {{ child.title }}
                      </span>
                    </span>
                    <span class="sidebar-link-text">{{ child.title }}</span>
                  </li>
                </ul>
              </li>

              <li
                v-if="profileType === 'jobSeeker'"
                class="mini-list-group-item nav-link nav-group"
                :class="{
                  'current-route':
                    $route.path === '/toolbox/settings' ||
                    $route.path === '/toolbox/billing' ||
                    $route.path === '/toolbox/users-management',
                }"
              >
                <button
                  class="nav-group-toggle"
                  type="button"
                  @click="jobSeekerItems.active = !jobSeekerItems.active"
                >
                  <span class="sidebar-link-icon">
                    <component :is="jobSeekerItems.icon" size="24" />
                    <span class="tooltipText" v-if="mini">
                      {{ jobSeekerItems.title }}
                    </span>
                  </span>
                  <span class="sidebar-link-text">
                    <span class="nav-group-title-row">
                      <span v-text="jobSeekerItems.title"></span>
                      <span
                        class="nav-group-chevron nav-group-chevron-inline"
                        :class="{ open: jobSeekerItems.active }"
                      >
                        <PhCaretDown size="16" weight="bold" />
                      </span>
                    </span>
                    <small>Job Seeker</small>
                  </span>
                </button>

                <ul v-show="jobSeekerItems.active" class="nav-group-items">
                  <li
                    v-for="child in jobSeekerItems.items"
                    :key="child.title"
                    class="nav-link mini-list-item"
                    :class="{ 'current-route': $route.path === child.to }"
                    @click="goTo(child.to)"
                  >
                    <span class="sidebar-link-icon">
                      <component :is="child.icon" size="24" />
                      <span class="tooltipText" v-if="mini">
                        {{ child.title }}
                      </span>
                    </span>
                    <span class="sidebar-link-text">{{ child.title }}</span>
                  </li>
                </ul>
              </li>

              <BNavItem
                :key="'Logout'"
                class="nav-link mini-list-item"
                @click="showLogoutModal"
              >
                <PhSignOut class="mr-2" size="24" />
                Logout
              </BNavItem>
            </BNavbarNav>
          </div>
        </BRow>
      </BContainer>
    </nav>
  </div>
</template>

<script>
import messagesMixin from "@/mixins/messagesMixin"
import SupportModal from "@/components/Modals/SupportModal"
import { hasProjectNotification as hasProjectNotificationHelper } from "@/utils/notifications"
import {
  PhUser,
  PhHandshake,
  PhHouse,
  PhUsers,
  PhBriefcase,
  PhMagnifyingGlass,
  PhSignOut,
  PhGear,
  PhCurrencyDollar,
  PhUserCircle,
  PhKey,
  PhCaretDown,
} from "@phosphor-icons/vue"

export default {
  mixins: [messagesMixin],
  components: {
    SupportModal,
    PhUser,
    PhHandshake,
    PhUsers,
    PhHouse,
    PhBriefcase,
    PhMagnifyingGlass,
    PhSignOut,
    PhGear,
    PhCurrencyDollar,
    PhUserCircle,
    PhKey,
    PhCaretDown,
  },
  props: {
    sidebarItems: {
      type: Array,
    },
    isNewApplicants: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const userProfile = this.$store.state.userProfile
    const profileType = userProfile?.jobSeeker ? "jobSeeker" : "company"
    const userdetails = this.$store.state.user

    const companyItems = {
      icon: "PhUserCircle",
      active: false,
      items: [
        { title: "Settings", icon: "PhGear", to: "/toolbox/settings" },
        { title: "Billing", icon: "PhCurrencyDollar", to: "/toolbox/billing" },
        {
          title: "User Management",
          icon: "PhUsers",
          to: "/toolbox/users-management",
        },
        { title: "Credentials", icon: "PhKey", to: "/toolbox/change-password" },
      ],
      title: [userdetails.firstName, userdetails.lastName]
        .filter(Boolean)
        .join(" "),
      companyName: userProfile.name,
    }

    const jobSeekerItems = {
      icon: "PhUserCircle",
      active: false,
      items: [
        { title: "Settings", icon: "PhGear", to: "/toolbox/settings" },
        { title: "Credentials", icon: "PhKey", to: "/toolbox/change-password" },
      ],
      title: userProfile.name,
    }

    return {
      activeNotifications: false,
      showMenu: false,
      searchQuery: "",
      selected: this.$store.state.userProfile.public,
      prof: this.$store.state.userProfile ?? null,
      profileType,
      jobSeekerItems,
      companyItems,
      mini: false,
    }
  },
  computed: {
    unreadCount() {
      return this.$store.state.messaging.unreadCount
    },
    profile() {
      return this.$store.state.userProfile
    },
    initials() {
      const { name } = this.$store.state.userProfile
      const names = name.split(" ")
      const firstName = names[0]
      const lastName = names.length > 1 ? names.slice(-1)[0] : null
      const initials =
        firstName.charAt(0) + (lastName ? lastName.charAt(0) : "")
      return initials
    },
    jobApplications() {
      return this.$store.state.userProfile.profilesRequested.filter(
        (i) => i.type == "job-application"
      )
    },
    jobBriefings() {
      return this.$store.state.userProfile.profilesRequested.filter(
        (i) => i.type == "job"
      )
    },
    hasJobBriefingNotification() {
      const profile = this.$store.state.userProfile
      if (!profile) return false

      return (
        profile.type === "jobSeeker" &&
        profile.profilesRequested?.findIndex(
          (x) => x.type === "job" && x.profile !== profile._id
        ) > -1
      )
    },
    hasProjectNotification() {
      const projects = this.$store.state.projects?.list || []
      const profilesRequested =
        this.$store.state.userProfile?.profilesRequested || []
      return hasProjectNotificationHelper(projects, profilesRequested)
    },
  },
  created() {
    this.updateProfile()
  },
  watch: {
    "$store.state.userProfile": {
      handler(newValue) {
        this.prof = newValue
      },
      deep: true,
    },
    $route() {
      this.showMenu = false
    },
  },
  methods: {
    async updateProfile() {
      const type = this.$store.state.userProfile.type
      await this.$store.dispatch(
        `api/${
          type == "jobSeeker" ? "getUserProfile" : "getCompanyUserProfile"
        }`,
        {
          userId: this.$store.state.user._id,
        }
      )
    },
    goTo(path) {
      this.showMenu = false
      this.$router.push(path)
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false)
    },
    toggleMenu() {
      this.showMenu = !this.showMenu
    },
    showLogoutModal() {
      this.$bvModal.show("logout-modal")
    },
    async handleLogout() {
      try {
        await this.$router.replace("/logout")
      } catch (error) {
        this.showErrorMessage(error, "We couldn't revoke your credentials.")
      }
    },
    handleSupportModal() {
      this.showMenu = false
      this.$bvModal.show("support-modal")
    },
    async sendSupportRequest(data) {
      try {
        const profile = this.$store.state.userProfile
        const { id, type } = profile
        await this.$store.dispatch(
          `api/${type == "jobSeeker" ? "sendSupport" : "sendCompanySupport"}`,
          {
            data,
            profileId: id,
          }
        )
        this.$bvModal.hide("support-modal")
        this.$toast.success("Support request sent!")
      } catch (e) {
        this.$toast.error("Error sending support request")
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.topnav-toggle {
  position: absolute;
  right: 15px;

  .navbar-toggler-icon {
    font-size: 1.25rem;
  }
}

.topnav-container {
  width: 100%;
  position: relative;
}

.nav-item-with-dot {
  position: relative;
}

.nav-title {
  position: relative;
  display: inline-block;
}

.notification-dot {
  position: absolute;
  top: -10px;
  right: -15px;
  width: 10px;
  height: 10px;
  background: #fa0000;
  border-radius: 50%;
  border: 2px solid #fff;
}

.unread-count-badge {
  position: absolute;
  top: -12px;
  right: -20px;
}

.v-list-group__items {
  .nav-link {
    display: flex !important;
  }
}

.v-list-item__title {
  font-size: 18px !important;
}

.mini-list-group-item.nav-link .v-list-item__icon svg {
  margin-left: 0px !important;
}

.avatar-icon {
  font-family: var(--font-family-base);
  font-size: 3rem;
  font-weight: bold;
  width: 100%;
  height: 100%;
}

.b-dropdown {
  background: white !important;
  border-radius: 14px !important;
  border: 1px solid #273057;

  .dropdown-toggle {
    background: white !important;
    border-radius: 14px !important;
  }
}

.nav-link.current-route {
  background: var(--gfb-blue-brand-70050-opacity, rgba(0, 82, 124, 0.5));
  border-radius: 8px !important;
}

.sidebar-link-icon {
  display: inline-flex;
  align-items: center;
  position: relative;
  margin-right: 10px;
}

.sidebar-link-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  white-space: nowrap;
}

.nav-group-title-row {
  display: inline-flex;
  align-items: center;
}

.sidebar-link-text small {
  opacity: 0.8;
  font-size: 12px;
}

.nav-group {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.nav-group-toggle {
  width: 100%;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  display: flex;
  align-items: center;
  padding: 0;
}

.nav-group-chevron {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  transition: transform 0.2s ease;
}

.nav-group-chevron-inline {
  margin-left: 5rem;
  margin-right: 6px;
}

.nav-group-chevron.open {
  transform: rotate(180deg);
}

.nav-group-items {
  list-style: none;
  margin: 0;
  padding: 0;

  .nav-link {
    display: flex;
  }
}

@media (max-width: 767.98px) {
  #topnav {
    background: var(--dark-bg) !important;
  }

  #topnav .nav-link {
    padding: 30px !important;
    padding-bottom: 16px !important;
    color: #ffffff !important;
  }

  .navbar-collapse.collapsing,
  .navbar-collapse.show {
    position: relative;
    background: var(--dark-bg) !important;
  }

  #navbar-main {
    display: none;
  }
}

@media (min-width: 767.99px) {
  #topnav {
    display: none;
  }
}
</style>
